var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',[_c('chartjs-component-bar-chart',{attrs:{"height":400,"data":_vm.chartjsData.latestBarChart.data,"options":_vm.chartjsData.latestBarChart.options,"images-label":_vm.imagesLabel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }